import PropTypes from "prop-types";
import { useMemo } from "react";
import AlertModal from "../AlertModal";
import { MESSAGE_MODAL_TEXT, MESSAGE_MODAL_CONFIG } from "./constants.js";
import { formatMessagePayload } from "./utils.js";
import "./styles.scss";

export default function MessageModal({ open, messages, onClose, title = MESSAGE_MODAL_TEXT.DEFAULT_TITLE }) {
  const formattedString = useMemo(() => formatMessagePayload(messages), [messages]);

  return (
    <>
      <AlertModal
        open={open}
        title={title}
        actionText={MESSAGE_MODAL_TEXT.CLOSE_ACTION}
        onAction={onClose}
        messageData={formattedString}
      >
        <pre className="message-modal__pre">{formattedString}</pre>
      </AlertModal>

      {open && (
        <div className="message-modal__hint" style={{ zIndex: MESSAGE_MODAL_CONFIG.HINT_Z_INDEX }}>
          <span className="message-modal__hint-content">{MESSAGE_MODAL_TEXT.NAVIGATION_HINT}</span>
        </div>
      )}
    </>
  );
}

MessageModal.propTypes = {
  open: PropTypes.bool,
  messages: PropTypes.any,
  onClose: PropTypes.func,
  title: PropTypes.string,
};
